var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 100,
    height: 100,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 30.990234 2.9863281 A 1.0001 1.0001 0 0 0 30.292969 3.2929688 L 25 8.5859375 L 19.707031 3.2929688 A 1.0001 1.0001 0 0 0 18.990234 2.9902344 A 1.0001 1.0001 0 0 0 18.292969 4.7070312 L 22.585938 9 L 17 9 C 10.936593 9 6 13.936593 6 20 L 6 36 C 6 42.063407 10.936593 47 17 47 L 33 47 C 39.063407 47 44 42.063407 44 36 L 44 20 C 44 13.936593 39.063407 9 33 9 L 27.414062 9 L 31.707031 4.7070312 A 1.0001 1.0001 0 0 0 30.990234 2.9863281 z M 17 11 L 25.015625 11 L 33 11 C 37.982593 11 42 15.017407 42 20 L 42 36 C 42 40.982593 37.982593 45 33 45 L 17 45 C 12.017407 45 8 40.982593 8 36 L 8 20 C 8 15.017407 12.017407 11 17 11 z M 24.970703 24 A 1.0001 1.0001 0 0 0 24.757812 24.029297 L 12.757812 27.029297 A 1.0004596 1.0004596 0 1 0 13.242188 28.970703 L 24 26.28125 L 24 31 A 1.0001 1.0001 0 0 0 25.242188 31.970703 L 37.242188 28.970703 A 1.0004596 1.0004596 0 1 0 36.757812 27.029297 L 26 29.71875 L 26 25 A 1.0001 1.0001 0 0 0 24.970703 24 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNf);
export default __webpack_public_path__ + "static/media/NF.fe9147fa6696bbb3b8327c76d5b1cf0a.svg";
export { ForwardRef as ReactComponent };